import React from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import '../pages/AnimationsAndStyles.css';

export default function Profile() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  let user = null;

  if (token) {
    try {
      user = jwtDecode(token);
    } catch (err) {
      console.error("Invalid token", err);
    }
  }

  /* ================= LOGOUT ================= */

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/", { replace: true });
    window.location.reload();
  };

  if (!user) {
    return (
      <div style={page}>
        <style>{css}</style>

        <div style={styles.centeredCard}>
          <div style={styles.emptyIcon}>🔓</div>
          <h2>Session Expired</h2>
          <p style={styles.emptyText}>Please login again to continue.</p>
          <button style={styles.buttonDanger} onClick={handleLogout}>
            🔄 Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={page}>
      <style>{css}</style>

      <div style={styles.container}>
        {/* Header */}
        <div style={styles.profileCard}>
          <div style={styles.cardHeader}>
            <div>
              <h2 style={styles.title}>👤 My Profile</h2>
              <p style={styles.subtitle}>Account information & settings</p>
            </div>
            <span style={styles.roleBadge}>{user.role}</span>
          </div>

          <div style={styles.divider} />

          {/* Profile Info */}
          <div style={styles.profileInfo}>
            <ProfileField label="👤 Full Name" value={user.name} />
            <ProfileField label="✉️ Email Address" value={user.email} />
            <ProfileField label="🎯 Role" value={user.role} />
          </div>

          <div style={styles.divider} />

          {/* Logout */}
          <div style={styles.logoutBox}>
            <div>
              <strong>⚠️ Logout</strong>
              <p style={styles.logoutSubtext}>
                This will end your current session.
              </p>
            </div>
            <button style={styles.buttonDanger} onClick={handleLogout}>
              🚪 Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= PROFILE FIELD ================= */

const ProfileField = ({ label, value }) => (
  <div style={styles.field}>
    <label style={styles.fieldLabel}>{label}</label>
    <div style={styles.fieldValue}>{value || "-"}</div>
  </div>
);

/* ================= STYLES ================= */

const styles = {
  container: {
    maxWidth: '700px',
    margin: '0 auto',
  },
  profileCard: {
    background: '#FFFFFF',
    color: '#0F172A',
    padding: '28px',
    borderRadius: '18px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.25)',
    animation: 'fadeInUp 0.6s ease-out',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  title: {
    margin: '0 0 8px 0',
    fontSize: '26px',
    fontWeight: '700',
    fontFamily: "'Poppins', sans-serif",
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748B',
    margin: '0',
  },
  roleBadge: {
    background: 'linear-gradient(135deg, #1E40AF, #1e3a8a)',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
    boxShadow: '0 4px 12px rgba(30, 64, 175, 0.3)',
  },
  divider: {
    height: '1px',
    background: '#E2E8F0',
    margin: '20px 0',
  },
  profileInfo: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '16px',
    marginBottom: '16px',
  },
  field: {
    animation: 'fadeInUp 0.5s ease-out',
  },
  fieldLabel: {
    fontSize: '13px',
    color: '#64748B',
    marginBottom: '6px',
    display: 'block',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  fieldValue: {
    background: 'linear-gradient(135deg, #F8FAFC, #F0F4FF)',
    padding: '12px 16px',
    borderRadius: '10px',
    border: '1px solid #E2E8F0',
    fontSize: '15px',
    fontWeight: '500',
    color: '#0F172A',
  },
  logoutBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    background: '#FEF2F2',
    borderRadius: '12px',
    animation: 'fadeInUp 0.6s ease-out 0.1s both',
  },
  logoutSubtext: {
    fontSize: '13px',
    color: '#64748B',
    margin: '4px 0 0 0',
  },
  buttonDanger: {
    background: 'linear-gradient(135deg, #EF4444, #DC2626)',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '10px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
    transition: 'all 0.3s ease',
  },
  centeredCard: {
    maxWidth: '500px',
    margin: 'auto',
    background: '#FFFFFF',
    color: '#0F172A',
    padding: '40px 28px',
    borderRadius: '18px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.25)',
    textAlign: 'center',
    animation: 'scaleIn 0.5s ease-out',
  },
  emptyIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  emptyText: {
    color: '#64748B',
    fontSize: '14px',
    margin: '12px 0 20px 0',
  },
};

const page = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #0F172A, #1E3A8A)",
  padding: "32px",
  fontFamily: "Inter, sans-serif",
  color: "#FFFFFF",
};

const css = `
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.card {
  max-width: 640px;
  margin: auto;
  background: #FFFFFF;
  color: #0F172A;
  padding: 28px;
  border-radius: 18px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.25);
}

.center {
  text-align: center;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subtitle {
  font-size: 14px;
  color: #64748B;
  margin-top: 4px;
}

.role-badge {
  background: #1E40AF;
  color: white;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
}

.divider {
  height: 1px;
  background: #E5E7EB;
  margin: 20px 0;
}

.profile-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.profile-field label {
  font-size: 13px;
  color: #64748B;
  margin-bottom: 4px;
  display: block;
  font-weight: 600;
}

.profile-field .value {
  background: #F8FAFC;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 15px;
  font-weight: 500;
}

.logout-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.muted {
  font-size: 13px;
  color: #64748B;
}

.btn {
  padding: 10px 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.btn.danger {
  background: #DC2626;
  color: white;
}
`;

// import React from "react";
// import { jwtDecode } from "jwt-decode";
// import { useNavigate } from "react-router-dom";

// export default function Profile() {
//   const navigate = useNavigate();

//   // Decode token safely
//   const token = localStorage.getItem("token");
//   let user = null;

//   if (token) {
//     try {
//       user = jwtDecode(token);
//     } catch (err) {
//       console.error("Invalid token", err);
//     }
//   }

//   // ================= LOGOUT =================
//   const handleLogout = () => {
//     // Remove token
//     localStorage.removeItem("token");

//     // Optional: clear everything
//     // localStorage.clear();

//     // Redirect to login
//     navigate("/", { replace: true });

//     // Force refresh to reset app state
//     window.location.reload();
//   };

//   if (!user) {
//     return (
//       <div className="card">
//         <h2>Session expired</h2>
//         <button onClick={handleLogout}>Go to Login</button>
//       </div>
//     );
//   }

//   return (
//     <div className="card">
//       <h1>Profile</h1>

//       <div className="profile-field">
//         <label>Name</label>
//         <p>{user.name}</p>
//       </div>

//       <div className="profile-field">
//         <label>Email</label>
//         <p>{user.email}</p>
//       </div>

//       <div className="profile-field">
//         <label>Role</label>
//         <p>{user.role}</p>
//       </div>

//       <hr style={{ margin: "20px 0" }} />

//       {/* LOGOUT BUTTON */}
//       <button
//         onClick={handleLogout}
//         style={{
//           background: "#dc3545",
//           color: "#fff",
//           padding: "10px 18px",
//           border: "none",
//           borderRadius: "6px",
//           cursor: "pointer",
//           fontWeight: "600"
//         }}
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// // import React from 'react';
// // import { jwtDecode } from 'jwt-decode';

// // export default function Profile() {
// //   const user = jwtDecode(localStorage.getItem('token'));

// //   return (
// //     <div className="card">
// //       <h1>Profile</h1>

// //       <div className="profile-field">
// //         <label>Name</label>
// //         <p>{user.name}</p>
// //       </div>

// //       <div className="profile-field">
// //         <label>Email</label>
// //         <p>{user.email}</p>
// //       </div>

// //       <div className="profile-field">
// //         <label>Role</label>
// //         <p>{user.role}</p>
// //       </div>
// //     </div>
// //   );
// // }

// // // import React from 'react';

// // // export default function Profile() {
// // //   return (
// // //     <div className="card">
// // //       <h1>Profile</h1>
// // //       <p>This is the Profile page. View and edit your profile here.</p>
// // //     </div>
// // //   );
// // // }
